import React from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { x: '07 Oct', y: 3500 },
  { x: '08 Oct', y: 5000 },
  { x: '09 Oct', y: 6500 },
  { x: '10 Oct', y: 7200 },
];

const WeightScatterChart = () => {
  return (
    <div className="chart-container p-4 bg-white rounded-[16px] shadow-[0px_5px_20px_rgba(0,0,0,0.3)] ">
      <h2 className="text-[20px] mb-4 font-itcmedium text-[#007696]">Peso promedio</h2>
      <ResponsiveContainer width="100%" height={300}>
        <ScatterChart
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
          <CartesianGrid />
            <XAxis 
              type="category" 
              dataKey="x" 
              name="Fecha"  
            />
            <YAxis 
              type="number" 
              dataKey="y" 
              name="Peso" 
              unit="kg" 
              domain={[3000, 8000]} 
              tickCount={6} 
            />
            <Tooltip cursor={{ strokeDasharray: '3 3' }} />
          <Scatter name="Peso Promedio" data={data} fill="#82ca9d" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeightScatterChart;